// extracted by mini-css-extract-plugin
module.exports =  {"content":"a10a3f92e9--content--EA3yL","animated":"a10a3f92e9--animated--_KGFD"};